import {
    createResource,
    createDocumentResource,
    deleteResource,
    getResource,
    getResourceSilent,
    updateResource
} from "../actions/resource";

export const getDataSelect = ({ dispatch, user }) => ({ query, resource }) =>
    dispatch(getResource({
        user,
        query,
        resource
    }));

export const getDataSilentSelect = ({ dispatch, user }) => ({ query, resource }) =>
    dispatch(getResourceSilent({
        user,
        query,
        resource
    }));

export const createDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(createResource({
        user,
        ...object
    }));

export const createDocumentDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(createDocumentResource({
        user,
        ...object
    }));

export const updateDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(updateResource({
        user,
        ...object
    }));

export const deleteDataSelect = ({ dispatch, user }) => ({
                                                             query,
                                                             piggyQuery,
                                                             resource,
                                                             infoPiggyResource,
                                                             piggyResource,
                                                             stackedPiggyResource,
                                                             secondPiggyResource,
                                                             notificationMessage
                                                         }) =>
    dispatch(deleteResource({
        user,
        query,
        resource,
        piggyResource,
        infoPiggyResource,
        stackedPiggyResource,
        secondPiggyResource,
        piggyQuery: piggyQuery ?? query,
        notificationMessage
    }));